import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BadgeComponent } from '../common/badge/badge.component';
import type { BadgeColor } from '../common/badge/badge.types';
import { BoxComponent } from '../common/box/box.component';
import { HeadingComponent } from '../common/heading/heading.component';
import { IconComponent } from '../common/icon/icon.component';
import type { IconName } from '../icons-container/icons.type';

@Component({
  selector: 'rt-new-item-button',
  templateUrl: 'new-item-button.component.html',
  styleUrls: ['./new-item-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeComponent, BoxComponent, HeadingComponent, IconComponent],
})
export class NewItemButtonComponent {
  @Input() public icon: IconName;
  @Input() public heading: string = '';
  @Input() public subheading: string = '';
  @Input() public badgeText?: string;
  @Input() public badgeVariant: BadgeColor;
  @Input() public disabled = false;
}
